import { render, staticRenderFns } from "./ClueArchives.vue?vue&type=template&id=04791104&"
import script from "./ClueArchives.vue?vue&type=script&lang=js&"
export * from "./ClueArchives.vue?vue&type=script&lang=js&"
import style0 from "./ClueArchives.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports